"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableDisplayName = getTableDisplayName;
/**
 * Returns the label shown for a table in checkout and proximity UI.
 * Uses `||` so an empty string in `descriptiveName` falls back to `name`.
 * To treat only `null`/`undefined` as missing, use `??` instead of `||`.
 */
function getTableDisplayName(table) {
    return table.descriptiveName || table.name;
}
//# sourceMappingURL=getTableDisplayName.js.map